import { createSelector } from "@reduxjs/toolkit";
import { getProductPickerProducts } from "@src/store/slices/productPicker";
import { ProductPickerProduct } from "@src/store/slices/productPicker/types";

export const getProductPickerProductMap = createSelector(
  getProductPickerProducts,
  (products) =>
    products.reduce(
      (lookup, product) => {
        lookup[product.id] = product;
        return lookup;
      },
      {} as Record<string, ProductPickerProduct>
    )
);
